/* Global imports. */
import React from "react";

/* Other imports. */
import { resolveInternalURL, resolveLinkTarget } from "@src/helpers";

interface Props {
  text: string;
  link: string;
  alignment: "left" | "right" | "centre";
}

const Button = ({ text, link, alignment }: Props) => {
  const alignmentClass = () => {
    switch (alignment) {
      case "left":
        return "text-left";
      case "right":
        return "text-right";
      default:
        return "text-center";
    }
  };

  return (
    <p className={alignmentClass()}>
      <a href={resolveInternalURL(link)} target={resolveLinkTarget(link)} className="button">
        {text}
      </a>
    </p>
  );
};

export default Button;
